import { useMemo } from 'react';
import dayjs from 'lib/dayjs';
import { useGetUnplannedLeavesQuery } from 'redux/features/employeeLeaveApi';
import { getUnplannedState } from 'utils/unplanned';

// Number of the employee's unplanned leaves that still need an action (request leave / add log).
// Looks at this and last month; leave / log mutations invalidate the same tag, so it stays current.
const useUnplannedActionCount = (userId, skip = false) => {
  const now = dayjs();
  const prev = now.subtract(1, 'month');
  const skipQuery = skip || !userId;

  const { data: current } = useGetUnplannedLeavesQuery(
    { month: now.month() + 1, year: now.year(), userId, limit: 100 },
    { skip: skipQuery },
  );
  const { data: previous } = useGetUnplannedLeavesQuery(
    { month: prev.month() + 1, year: prev.year(), userId, limit: 100 },
    { skip: skipQuery },
  );

  return useMemo(() => {
    const rowsOf = (res) => {
      const rows = res?.data || res || [];
      return Array.isArray(rows) ? rows : [];
    };
    const open = new Map();
    [...rowsOf(current), ...rowsOf(previous)].forEach((row) => {
      if (getUnplannedState(row).key === 'action') open.set(row.id, row);
    });
    return open.size;
  }, [current, previous]);
};

export default useUnplannedActionCount;
